var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { staticClass: "app-header navbar" },
    [
      _c(
        "button",
        {
          staticClass:
            "navbar-toggler mobile-sidebar-toggler d-lg-none mobile-header",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.mobileSidebarToggle.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "userInfo" }, [
            _c("span", { staticClass: "mobile-navbar" }, [
              _c("i", { staticClass: "mobile-icon-out" }, [
                _c(
                  "button",
                  { staticClass: "logoutBtn", on: { click: _vm.logout } },
                  [_vm._v("log out")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "navbar-toggler sidebar-toggler d-md-down-none",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.sidebarToggle.apply(null, arguments)
            },
          },
        },
        [_c("span", { staticClass: "navbar-toggler-icon" })]
      ),
      _vm._v(" "),
      _c("button", { staticClass: "searchBtn", on: { click: _vm.goHome } }, [
        _c("i", { staticClass: "icon-home" }),
        _vm._v(" "),
        _c("span", [_vm._v("LEAKBOT")]),
        _vm._v(" "),
        _vm.$store.getters.roleID === _vm.Roles.ADMIN
          ? _c("span", [_vm._v("SUPPORT")])
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.roleID === _vm.Roles.SUPER_ADMIN
          ? _c("span", [_vm._v("SUPPORT")])
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.roleID === _vm.Roles.MAINTENANCE
          ? _c("span", [_vm._v("INSURER")])
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.roleID === _vm.Roles.EXT_OPS
          ? _c("span", [_vm._v("INSURER SUPPORT")])
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.roleID === _vm.Roles.DEVICE_CONFIGURATION_MANAGER
          ? _c("span", [_vm._v("DEVICE CONFIGURATION MANAGER")])
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.roleID === _vm.Roles.INSURANCE
          ? _c("span", [_vm._v("INSURER")])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "b-nav",
        { staticClass: "ml-auto", attrs: { "is-nav-bar": "" } },
        [
          _c("li", { staticClass: "lbv-welcome" }, [
            _vm._v("\n      Welcome, \n      "),
            _vm.$store.getters.roleID === "1"
              ? _c("span", [_vm._v("Admin")])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.roleID === "2"
              ? _c("span", [_vm._v("2")])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.roleID === "3"
              ? _c("span", [_vm._v("Maintenance Manager")])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.roleID === "4"
              ? _c("span", [_vm._v("Device Configuration Manager")])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.roleID === "5"
              ? _c("span", [_vm._v("Super Admin")])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.roleID === "6"
              ? _c("span", [_vm._v("6")])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.roleID === "7"
              ? _c("span", [_vm._v("Analytics")])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.roleID === "8"
              ? _c("span", [_vm._v("External Operations")])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.roleID === _vm.Roles.INSURANCE
              ? _c("span", [_vm._v("Insurance Manager")])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.roleID === "9"
              ? _c("span", [_vm._v("9")])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.roleID === "0"
              ? _c("span", [_vm._v("0")])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "button",
              { staticClass: "logoutBtn", on: { click: _vm.logout } },
              [_c("span", [_vm._v("Logout")])]
            ),
          ]),
          _vm._v(" "),
          _c("HeaderDropdown"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }